module.exports = __webpack_public_path__ + "img/B552.7990870f.jpg";